import { Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AuthService } from '@auth0/auth0-angular';
import { AuthManagerService } from '@services/auth-manager.service';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'user',
})
export class UserComponent implements OnDestroy {
  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    @Inject(DOCUMENT) private _document: any,
    public AUTH: AuthService,
    public authManagerService: AuthManagerService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   * @param status
   */
  updateUserStatus(status: string): void {
    // Update the user data
    // this.user.status = status;
    // Update the user on the server
    // this._userService.update(this.user);
  }

  /**
   * Update the selected theme
   * @param event
   */
  updateTheme(event: MatSlideToggleChange): void {
    let mode: 'dark' | 'light' = event.checked ? 'dark' : 'light';
    // Find the class name for the previously selected theme and remove it
    this._document.body.classList.forEach((className: any) => {
      if (className.startsWith('theme-')) {
        this._document.body.classList.remove(className);
        return;
      }
    });

    // Add class name for the currently selected theme
    this._document.body.classList.add('theme-' + mode);
  }

  logout() {
    localStorage.removeItem('company');
    sessionStorage.removeItem('userInactivity');
    this.authManagerService.logout();
  }
}
